import ky from 'ky';
import { readCookie } from '@/utils/cookie'

const isCrossDomain = (url: string) => window.location.host !== new URL(url).host;
const token = readCookie('XSRF-TOKEN');

export default ky.extend({
	hooks: {
		beforeRequest: [
			request => {
                if (token && !isCrossDomain(request.url)) {
                    request.headers.set('X-XSRF-TOKEN', decodeURIComponent(token));
                }
			}
		]
	}
})
